<template>
  <div class="w-full flex-1 p-15px">
    <!-- 发布 -->
    <template v-if="type === 'release'">
      <Release @fresh="fresh" @cancel="type = 'lists'"
    /></template>

    <!-- 列表 -->
    <template v-else>
      <el-button
          type="primary"
          class="mb-20px mx-10px"
          @click="release"
          >发布讨论</el-button
        >
      <div class="w-full h-full flex flex-col">
        <template class="flex-1 overflow-y-auto" v-loading="loading">
          <div
            v-for="(item, index) in lists"
            :key="index"
            @click="goDetail(item)"
            class="mb-20px mx-10px p-15px rounded-5px cursor-pointer list"
          >
            <div class="text-black font-bold text-21px">{{ item.title }}</div>
            <div class="mt-10px" v-html="item.cotent"></div>
            <div class="flex mt-15px text-default">
              <avatar
                v-if="item.avatar"
                :src="item.avatar"
                class="w-21px h-21px"
              />
              <span class="flex-1 text-19px">{{ item.user_name }}</span>
              <span>{{ item.views }} 浏览</span>
              <span class="mx-5px"> | </span>
              <span>{{ item.reply_count }} 回复</span>
              <span class="ml-15px">{{ item.create_at }}</span>
            </div>
          </div>
        </template>
        <el-pagination
          class="h-53px flex items-center justify-center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          hide-on-single-page
        >
        </el-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import Release from './release.vue'
import dayjs from 'dayjs'
import avatar from '@/components/avatar.vue'
import { valiUsers } from '@/utils/validate'
export default {
  components: { Release, avatar },
  data() {
    return {
      type: 'lists',
      lists: [],
      pageSizes: [10, 20, 30, 40, 50, 100],
      pageSize: 10,
      pageNo: 1,
      total: 0
    }
  },
  computed: {
    project_id() {
      return this.$store.state.project.projectId;
    }
  },
  created() {
    this.getLists()
  },
  mounted() {},
  methods: {
    getLists() {
      this.loading = true
      this.$api.project
        .issuelist({
          project_id: this.project_id,
          baseReq: {
            page: this.pageNo, // 页码
            pageSize: this.pageSize
          }
        })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            res.data.list.forEach((item) => {
              item.create_at = dayjs(item.create_at).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            })
            this.lists = res.data.list
            this.total = res.data.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    goDetail(item) {
      this.$emit('listClick', item)
    },
    release() {
      const pass = valiUsers()
    if (pass) {
       this.type = 'release'
    }
     
    },
    fresh() {
      this.type = 'lists'
      this.pageNo = 1
      this.getLists()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNo = 1
      this.getLists()
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getLists()
    }
  }
}
</script>
<style lang="scss" scoped>

.list {
  background: #ebebeb;
  &:hover {
    background: #f4e9ff;
  }
}

</style>
